export const standingOrders = (state) => state.standingOrders;
